import Authorize from "../../components/Permission/Authorize";
import { Action, BasePermission, CMSPermission } from "../../enums/permissions";
import CMS from "./cms";
import Ecommerce from "./e-commerce";

function Dashboard() {
  return (
    <>
      <Authorize actions={[Action.READ]} subjects={[BasePermission.Order]}>
        <>
          <Ecommerce />
          <hr />
        </>
      </Authorize>
      <Authorize actions={[Action.READ]} subjects={[CMSPermission.Stats]}>
        <CMS />
      </Authorize>
    </>
  );
}

export default Dashboard;
